import { render, staticRenderFns } from "./mediapipe.vue?vue&type=template&id=a1ad76ae&scoped=true&"
import script from "./mediapipe.vue?vue&type=script&lang=js&"
export * from "./mediapipe.vue?vue&type=script&lang=js&"
import style0 from "./mediapipe.vue?vue&type=style&index=0&id=a1ad76ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ad76ae",
  null
  
)

export default component.exports